import { z } from 'zod';

import { TrapType } from 'components/AnalyticsPage/TrapType';

interface Encounter {
  id: number;
  discovery_date: string;
  pest_name: string | null;
  amount: number | null;
  pest_traces: string | null;
  witness: string;
  inspection_date: string;
  inspector: string;
  fixed: boolean;
}

interface Vulnetability {
  id: number;
  vul_pk: number;
  create_date: string;
  criticality: string;
  responsible: string;
  inspector: string;
  last_date: string;
  fix_date: string;
  category: string;
}

interface TrapData {
  id: number;
  serial_number: string;
  offline_start: string;
  offline_end: string;
  time_range: string;
  trap_number: number;
  lost_msgs: number;
  trap_type?: TrapType;
}

interface Signature {
  username: string;
  signature: string;
}

interface PeriodReport {
  id: number;
  object: string;
  start_date: string;
  end_date: string;
  encounter_list: Encounter[];
  vulnetability_list: Vulnetability[];
  trap_data_list: TrapData[];
  call_date: string;
  object_address: string;
  client_name: string;
  pest_signatured_by: Signature | null;
  customer_signatured_by: Signature | null;
  customer_signature: string;
}

interface User {
  name: string;
  image: string;
}

interface PeriodReportListItem {
  id: number;
  start_date: string;
  end_date: string;
  created_by: User;
  call_date: string;
  is_created: boolean;
}

// Period report create | Start Block |
export const createPeriodReportSchema = z.object({
  start_date: z.string(),
  end_date: z.string(),
});

export type CreatePeriodReportFormValues = z.infer<typeof createPeriodReportSchema>;
// Period report create | End Block |

export { Encounter, Vulnetability, TrapData, PeriodReport, PeriodReportListItem };
